import { useMeQuery } from '@/remote/user-management/fetch-me';

interface SiteManagementSearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  totalSites: number;
  filteredCount: number;
  onAddSite: () => void;
}

export default function SiteManagementSearchBar({
  searchTerm,
  onSearchChange,
  totalSites,
  filteredCount,
  onAddSite,
}: Readonly<SiteManagementSearchBarProps>) {
  const { data: me } = useMeQuery();
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-gray-400"></i>
              </div>
            </div>
            <input
              type="text"
              placeholder="관리번호, 현장ID, 주소, CDMA번호로 검색..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent w-96"
            />
          </div>
          {(me?.userLevel === 'SUPER_ADMINISTRATOR' ||
            me?.userLevel === 'HEADQUARTERS_MANAGER') && (
            <button
              onClick={onAddSite}
              className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-add-line"></i>
              </div>
              <span>새 현장 추가</span>
            </button>
          )}
        </div>
        <div className="text-sm text-gray-500">
          전체 현장: {totalSites}개 | 검색 결과: {filteredCount}개
        </div>
      </div>
    </div>
  );
}
